import { gql } from "@apollo/client";
export default gql`
  mutation RemoveAccount {
    removeAccount
  }
`;
